import { createFileRoute } from '@tanstack/react-router';

import BuslineSchedules from '@/modules/busline-schedules/pages/BuslineSchedules';

export const Route = createFileRoute(
  '/_authenticated/_system/busline-schedules/',
)({
  head: () => ({
    meta: [{ title: 'Linhas e Horários' }],
  }),
  component: BuslineSchedules,
});
